import { render } from "./CommonFslcCard.vue?vue&type=template&id=a88a898c"
import script from "./CommonFslcCard.vue?vue&type=script&lang=js"
export * from "./CommonFslcCard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\supportgroup\\admin.supportgroup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__